document.getElementById('header').innerHTML="\
<!DOCTYPE html>\
<html lang='en'>\
<head>\
  <title>CheckWata</title>\
  <meta charset='utf-8'>\
  <link href='https://fonts.googleapis.com/css?family=Barlow:300,300i,500,500i,900' rel='stylesheet'>\
</head>\
<body>\
    <nav>\
      <a href='index.html'><img id='logo_blue' alt='logo'></a>\
      <ul>\
        <li><a class='medium' id='popup' href='#'>CHECKNOW</a></li>\
        <li><a class='medium' href='./tipp.html'>TIPPS</a></li>\
      </ul>\
    </nav>\
  <div id='form_main'>\
  </div>"



// WEBPACK FOOTER //
// ./src/js/header.js